var _path, _path2, _path3, _path4, _path5, _ellipse, _g, _ellipse2, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 48,
    viewBox: "0 0 192 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.513 7.6155H120.959V8.16968V24.9837L120.959 25.0039C120.959 25.3238 120.959 25.6879 121.001 26.0156C121.519 32.882 127.099 38.3696 133.911 38.3696C141.105 38.3696 146.902 32.3441 146.902 24.9837C146.902 17.6215 141.108 11.5527 133.911 11.5527C129.92 11.5527 126.349 13.434 123.991 16.3893V8.16968V7.6155H123.437H121.513ZM133.907 14.6522C139.394 14.6522 143.87 19.2572 143.87 24.9837C143.87 30.6636 139.399 35.2701 133.907 35.2701C128.463 35.2701 123.987 30.665 123.987 24.9837C123.987 19.2557 128.465 14.6522 133.907 14.6522Z",
    fill: "#343744",
    stroke: "#343744",
    strokeWidth: 1.10835
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.756 13.614L172.748 13.6056L172.74 13.5976C170.271 11.0839 167.019 9.66262 163.55 9.66262C160.082 9.66262 156.829 11.0828 154.397 13.5991C151.915 16.1218 150.598 19.5245 150.598 23.0895C150.598 26.6556 151.916 30.016 154.395 32.5372C156.831 35.0997 160.087 36.4754 163.554 36.4754C167.023 36.4754 170.271 35.0539 172.744 32.5407L172.744 32.5407L172.748 32.5371C175.067 30.1363 176.217 27.1128 176.217 23.4295V22.4135V21.8593H175.662H173.739H173.184V22.4135V23.4295C173.184 26.356 172.363 28.5419 170.597 30.3699C168.698 32.3351 166.221 33.3759 163.55 33.3759C161.425 33.3759 159.361 32.671 157.66 31.3802L173.397 15.0921L173.757 14.7193L173.409 14.335L172.756 13.614ZM153.63 23.0854C153.63 20.3029 154.642 17.7304 156.542 15.7643C158.407 13.8376 160.92 12.7579 163.55 12.7539C165.713 12.754 167.747 13.4582 169.479 14.7536L155.543 29.1773C154.307 27.4191 153.63 25.2855 153.63 23.0854Z",
    fill: "#343744",
    stroke: "#343744",
    strokeWidth: 1.10835
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8934 13.614L68.8858 13.6056L68.878 13.5976C66.408 11.0839 63.1564 9.66262 59.6871 9.66262C56.2193 9.66262 52.9664 11.0828 50.5343 13.5991C48.0523 16.1218 46.7351 19.5245 46.7351 23.0895C46.7351 26.6556 48.053 30.016 50.5326 32.5372C52.9688 35.0997 56.2242 36.4754 59.691 36.4754C63.1606 36.4754 66.408 35.0539 68.8816 32.5407L68.8816 32.5407L68.8852 32.5371C71.2048 30.1363 72.354 27.1128 72.354 23.4295V22.4135V21.8593H71.7998H69.8761H69.3219V22.4135V23.4295C69.3219 26.356 68.5004 28.5419 66.7343 30.3699C64.8355 32.3351 62.3587 33.3759 59.6871 33.3759C57.5624 33.3759 55.4981 32.671 53.7971 31.3802L69.5344 15.0921L69.8946 14.7193L69.5466 14.335L68.8934 13.614ZM49.7672 23.0854C49.7672 20.3029 50.7797 17.7304 52.6791 15.7643C54.5445 13.8376 57.058 12.7579 59.6874 12.7539C61.8505 12.754 63.8842 13.4582 65.6167 14.7536L51.6808 29.1773C50.4449 27.4191 49.7672 25.2855 49.7672 23.0854Z",
    fill: "#343744",
    stroke: "#343744",
    strokeWidth: 1.10835
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.7 36.4754H117.254V35.9212V23.0895C117.254 15.9073 112.276 9.66262 106.182 9.66262C102.115 9.66262 98.5635 12.4718 96.6512 16.435C94.741 12.4683 91.1861 9.66262 87.1186 9.66262C81.0293 9.66262 76.0508 15.9033 76.0508 23.0895V35.9212V36.4754H76.605H78.5288H79.083V35.9212V23.0895C79.083 20.2658 80.0265 17.6663 81.5122 15.782C82.9989 13.8965 84.9991 12.758 87.1225 12.758C89.2254 12.758 91.226 13.8957 92.7186 15.7827C94.2096 17.6677 95.1621 20.2672 95.1621 23.0895V35.9212V36.4754H95.7163H97.5966H98.1507V35.9212V23.0895C98.1507 20.2658 99.0942 17.6663 100.58 15.782C102.067 13.8965 104.067 12.758 106.19 12.758C108.316 12.758 110.316 13.8965 111.802 15.782C113.287 17.6661 114.23 20.2657 114.23 23.0895V35.9212V36.4754H114.784H116.7Z",
    fill: "#343744",
    stroke: "#343744",
    strokeWidth: 1.10835
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.91 35.9253V36.4795H180.464H182.388H182.942V35.9253V21.1025C182.942 17.6455 183.321 15.5968 184.218 14.3984C185.072 13.2557 186.505 12.7621 189.058 12.7621H190H190.554V12.2079V10.2168V9.66262H190H189.058C185.364 9.66262 183.005 10.7523 181.614 12.8439C180.262 14.878 179.91 17.7492 179.91 21.1025V35.9253Z",
    fill: "#343744",
    stroke: "#343744",
    strokeWidth: 1.10835
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1136,
    cy: 25.5529,
    rx: 5.02106,
    ry: 13.817,
    transform: "rotate(135 29.1136 25.5529)",
    fill: "url(#paint0_linear_371_1420)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iiii_371_1420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9475 20.1932C29.7854 27.5115 25.8768 32.8071 23.2174 32.0214C20.558 31.2357 20.1548 24.6662 22.3169 17.348C24.479 10.0298 28.3876 4.7341 31.047 5.5198C33.7064 6.30549 34.1096 12.875 31.9475 20.1932Z",
    fill: "url(#paint1_linear_371_1420)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter1_iiii_371_1420)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_371_1420",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 15,
    width: 22,
    height: 21
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1144,
    cy: 25.5528,
    rx: 5.02106,
    ry: 13.817,
    transform: "rotate(135 29.1144 25.5528)",
    fill: "#E778FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_371_1420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9476 20.1947C29.7855 27.5129 25.8769 32.8086 23.2175 32.0229C20.558 31.2372 20.1549 24.6677 22.317 17.3495C24.4791 10.0312 28.3877 4.73556 31.0471 5.52126C33.7065 6.30696 34.1097 12.8765 31.9476 20.1947Z",
    fill: "#E778FF"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_iiii_371_1420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1504 34.9996C36.9672 37.9097 34.0073 40.1449 30.6108 41.4484C27.2143 42.7519 23.519 43.0708 19.9494 42.3685C16.3798 41.6661 13.0808 39.971 10.4313 37.478C7.78177 34.9849 5.88932 31.7949 4.97134 28.2746C4.05336 24.7543 4.1471 21.0464 5.24177 17.577C6.33644 14.1076 8.38764 11.0173 11.1597 8.66128C13.9318 6.30525 17.3123 4.77902 20.9128 4.25793C24.5133 3.73685 28.1878 4.24205 31.5141 5.7155C20.907 14.8578 25.4301 32.1985 39.1504 34.9996Z",
    fill: "url(#paint2_linear_371_1420)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_371_1420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2298 35.077C37.0443 37.9245 34.0908 40.1188 30.7087 41.4077C27.3266 42.6966 23.653 43.028 20.1101 42.3636C16.5672 41.6993 13.2987 40.0662 10.68 37.6521C8.06131 35.2379 6.19875 32.1406 5.30629 28.716C4.41383 25.2914 4.52767 21.6784 5.63474 18.2921C6.7418 14.9058 8.79719 11.8836 11.5647 9.57265C14.3323 7.26175 17.6998 5.7559 21.2802 5.22811C24.8607 4.70032 28.5089 5.172 31.8058 6.58896C21.3513 15.4401 25.7844 32.4581 39.2298 35.077Z",
    fill: "url(#paint3_linear_371_1420)",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iiii_371_1420",
    x: 18.4609,
    y: 4.20989,
    width: 16.11,
    height: 30.3541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.46523,
    dy: -1.23261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_371_1420"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.295828,
    dy: -0.147914
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.369784
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_371_1420",
    result: "effect2_innerShadow_371_1420"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.23261,
    dy: 2.46523
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_371_1420",
    result: "effect3_innerShadow_371_1420"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.197218,
    dy: 0.197218
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.369784
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_371_1420",
    result: "effect4_innerShadow_371_1420"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_iiii_371_1420",
    x: 18.461,
    y: 13.9222,
    width: 16.11,
    height: 20.6433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.46523,
    dy: -1.23261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_371_1420"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.295827,
    dy: -0.147914
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.369784
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_371_1420",
    result: "effect2_innerShadow_371_1420"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.23261,
    dy: 2.46523
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_371_1420",
    result: "effect3_innerShadow_371_1420"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.197218,
    dy: 0.197218
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.369784
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_371_1420",
    result: "effect4_innerShadow_371_1420"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_iiii_371_1420",
    x: 1.88041,
    y: 2.82598,
    width: 38.5026,
    height: 42.3714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.46523,
    dy: -1.23261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_371_1420"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.295827,
    dy: -0.147914
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.369784
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_371_1420",
    result: "effect2_innerShadow_371_1420"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.23261,
    dy: 2.46523
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23261
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_371_1420",
    result: "effect3_innerShadow_371_1420"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.197218,
    dy: 0.197218
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.369784
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_371_1420",
    result: "effect4_innerShadow_371_1420"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_371_1420",
    x: 2.24629,
    y: 2.55284,
    width: 39.4487,
    height: 42.6099,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23261,
    result: "effect1_foregroundBlur_371_1420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_371_1420",
    x1: 28.7245,
    y1: 11.9171,
    x2: 36.3033,
    y2: 52.0821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.349773,
    stopColor: "#9223F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_371_1420",
    x1: 31.047,
    y1: 5.5198,
    x2: 23.2174,
    y2: 32.0214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C27EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787699,
    stopColor: "#E7A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_371_1420",
    x1: 20.3958,
    y1: 4.25708,
    x2: 20.8219,
    y2: 42.5799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451214,
    stopColor: "#C71EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994097,
    stopColor: "#6A27EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_371_1420",
    x1: 0.504496,
    y1: 13.5186,
    x2: 28.653,
    y2: 24.2929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmber);
export default __webpack_public_path__ + "static/media/ember.e0f0e142fb010c11e5dba3a81f6af9c0.svg";
export { ForwardRef as ReactComponent };